var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('transition',{attrs:{"name":"balloons"}},[(_vm.showBalloons)?_c('div',{staticClass:"balloons"},[_vm._v(_vm._s(_vm.balloonsContent))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }